import React from 'react';
import { Route } from 'react-router-dom';
import { BodyCliente } from './BodyCliente';

export const BodyTemplate = ({
    component: Component,
    ...rest
}) => {
    return (
        <Route {...rest}
        component={ (props)=>(
            <BodyCliente {...props}/>
        )
        }
        />
    )
}
